import { createSelector } from 'reselect'

import { RootState } from 'redux/store';
import { AOLMenu } from 'interfaces/aol';

const selectSearchMenu = createSelector(
  (state: RootState) => state.aol.searchMenu,
  (menu: AOLMenu[]) => menu
)

export default selectSearchMenu
